import { useQuery } from '@tanstack/react-query';
import { getDivisions } from '../../Shared/Services/Common';

const useGetDivisions = (includeInactive = false, includeSGA = false, options = {}) =>
    useQuery(
        ['divisions', includeInactive, includeSGA],
        () => getDivisions(includeInactive, includeSGA),
        options
    );

export default useGetDivisions;
